module.exports = __webpack_public_path__ + "img/gyerektamogatas.d3b1e1f7.jpg";